import http from '../http'

/**
 * 获取所有用户列表
 * @returns {Promise} 返回用户列表
 */
export function getAllUsers() {
  return http.get('/users')
}

/**
 * 分页查询用户信息
 * @param {Object} params 查询参数
 * @param {Number} [params.page] - 页码（从0开始）
 * @param {Number} [params.size] - 每页数量
 * @param {String} [params.realName] - 用户姓名(可选，支持模糊查询)
 * @param {String} [params.username] - 用户名(可选，支持模糊查询)
 * @param {Number} [params.unitId] - 单位ID(可选)
 * @returns {Promise} 返回用户信息列表和分页信息
 */
export function queryUsersPagination(params = {}) {
  return http.get('/users/page', { params })
}

/**
 * 根据ID获取用户详情
 * @param {Number|String} id - 用户ID
 * @returns {Promise} 返回用户详细信息
 */
export function getUserById(id) {
  return http.get(`/users/${id}`)
}

/**
 * 根据单位ID获取用户列表
 * @param {Number|String} unitId - 单位ID
 * @returns {Promise} 返回用户列表
 */
export function getUsersByUnitId(unitId) {
  return http.get(`/users/unit/${unitId}`)
}

/**
 * 根据项目ID列表获取用户（users表中project_ids包含任一项目ID的用户）
 * 用于合同关联项目时，需求方联系人只能选择项目内用户
 * @param {Array<Number>} projectIds - 项目ID数组
 * @returns {Promise} 返回用户列表
 */
export function getUsersByProjectIds(projectIds) {
  if (!projectIds || projectIds.length === 0) {
    return Promise.resolve({ data: { success: true, data: [] } })
  }
  const idsStr = projectIds.join(',')
  return http.get('/users/project', { params: { projectIds: idsStr } })
}

/**
 * 保存用户信息（新增或更新）
 * @param {Object} data 用户信息数据
 * @param {Number} [data.id] - 用户ID(更新时必填，新增时不填)
 * @param {String} data.username - 用户名(必填)
 * @param {String} data.realName - 真实姓名(必填)
 * @param {String} [data.email] - 邮箱(可选)
 * @param {String} [data.phone] - 手机号(可选)
 * @param {Number} [data.unitId] - 所属单位ID(可选)
 * @param {String} [data.role] - 用户角色(可选)
 * @returns {Promise} 返回保存结果
 */
export function saveUser(data) {
  return http.post('/users', data)
}

/**
 * 删除用户
 * @param {Number|String} id - 用户ID
 * @returns {Promise} 返回删除结果
 */
export function deleteUser(id) {
  return http.delete(`/users/${id}`)
}

/**
 * 更新用户状态
 * @param {Number|String} id - 用户ID
 * @param {String} status - 新状态
 * @returns {Promise} 返回更新结果
 */
export function updateUserStatus(id, status) {
  return http.put(`/users/${id}/status?status=${status}`)
}

export default {
  getAllUsers,
  queryUsersPagination,
  getUserById,
  getUsersByUnitId,
  saveUser,
  deleteUser,
  updateUserStatus
}
